import { createContext, useContext } from 'react';
import { IProfile } from '../../common/interfaces/profile.interface';

export interface AuthContextInterface {
  user: IProfile;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export const UserProfileContext = createContext<{
  user: IProfile | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}>({
  user: null,
  isAuthenticated: false,
  isLoading: false,
});

export const useUserProfile = () => {
  return useContext(UserProfileContext);
};
